import { Inject } from 'inversify-props'
import { VendaServiceAdapter } from './adapter'
import { Venda } from '@/models'

export class CancelarVendaUseCase {
	@Inject('VendaServiceAdapter')
	private vendaService!: VendaServiceAdapter

	cancelar = async (id: string, usuarioAutenticado: string | null, motivoDoCancelamento?: string): Promise<Venda> => {
		return await this.vendaService.cancelar(id, usuarioAutenticado, motivoDoCancelamento)
	}
}
